// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__zSBNl","actions":"style_actions__JOkEg","form":"style_form__xJitA"};